import { gql } from "@apollo/client"
export const GET_ARTICLES = gql`
  query GetArticles($fresh: Boolean) {
    getArticles(fresh: $fresh) {
      id
      inventoryID
      description
    }
  }
`
